import { render, staticRenderFns } from "./SupportProblem.vue?vue&type=template&id=6100ccb2"
import script from "./SupportProblem.vue?vue&type=script&lang=js"
export * from "./SupportProblem.vue?vue&type=script&lang=js"
import style0 from "./SupportProblem.vue?vue&type=style&index=0&id=6100ccb2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
